import { normalizeApiDate } from "@/utils/date";

type DateTimeFormat = "date" | "time" | "datetime" | "short" | "full" | "dateWithYear" | "datetimeWithYear" | "numericDate" | "longDate" | "weekdayDate";

type LocalDateTimeProps = {
	value: string | Date;
	format?: DateTimeFormat;
	className?: string;
};

function parseAsUtc(value: string | Date): Date {
	if (value instanceof Date) {
		return value;
	}
	return new Date(normalizeApiDate(value));
}

const dateFormats: Record<DateTimeFormat, Intl.DateTimeFormatOptions> = {
	date: { month: "short", day: "numeric" },
	time: { hour: "numeric", minute: "2-digit", hour12: true },
	datetime: { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true },
	short: { month: "numeric", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true },
	full: { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true },
	dateWithYear: { year: "numeric", month: "short", day: "numeric" },
	datetimeWithYear: { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true },
	numericDate: { year: "2-digit", month: "2-digit", day: "2-digit" },
	longDate: { year: "numeric", month: "long", day: "numeric" },
	weekdayDate: { weekday: "short", month: "short", day: "numeric" },
};

export function LocalDateTime({ value, format = "datetime", className }: LocalDateTimeProps) {
	const date = parseAsUtc(value);
	const formatted = date.toLocaleString("en-US", dateFormats[format]);
	return <span className={className}>{formatted}</span>;
}

export function formatLocalDate(value: string | Date, format: DateTimeFormat = "datetime"): string {
	const date = parseAsUtc(value);
	return date.toLocaleString("en-US", dateFormats[format]);
}